export default class VelocityScrollable {
    constructor(raf, movementCallback) {
        this.raf = raf;
        this.velocity = 0;
        this.threshold = 300;
        this.maxVelocity = 10;
        this.isActive = false;
        this.movementCallback = movementCallback;
    }

    stop() {
        this.isActive = false;
    }

    start() {
        this.isActive = true;
        this.waitForMovement();
    }

    waitForMovement() {
        this.raf.call(null, () => {
            this.move(this.velocity);
            this.waitForMovement();
        });
    }

    registerMovement(left, right) {
        if (this.isActive) {
            this.velocity = this.calculateVelocity(left, right);
        } else {
            this.velocity = 0;
        }
    }

    calculateVelocity(left, right) {
        if (left < this.threshold) {
            return ((this.threshold - left) / this.threshold) * -this.maxVelocity;
        } else if (right < this.threshold) {
            return ((this.threshold - right) / this.threshold) * this.maxVelocity;
        } else {
            return 0;
        }
    }

    move(offset) {
        this.movementCallback(offset);
    }
}



// WEBPACK FOOTER //
// ./src/web/js/marketing/models/velocity-scrollable-model.js